import getMatchingVariant from './getMatchingVariant';

const UNAVAILABLE_ATTR = 'data-variant-unavailable';

// Marks each option value that, combined with the other selected options,
// has no variant (unavailable) or a sold-out one. Mirrors the server-side
// state product-variants.liquid renders from value.variant / value.available.
// inputSelector: the Select Option boxes' pickers use data-select-option-input
// radios (named per product, option name in data-option-name) and pass their
// box as `form`
const updateVariantAvailability = ({
  selectedOptions,
  variantsData,
  optionNames,
  form,
  strings = {},
  inputSelector = '[data-variant-input]'
}) => {
  const labelEls = form.querySelectorAll('[data-variant-label]');
  if (!labelEls.length) return;

  labelEls.forEach((labelEl) => {
    // The input is the label's sibling in the same wrapper — avoids the id,
    // which is handleized and can collide for near-identical values
    const inputEl = labelEl.parentElement?.querySelector(inputSelector);
    if (!inputEl) return;

    const optionName = inputEl.dataset.optionName || inputEl.name;
    const candidateOptions = { ...selectedOptions, [optionName]: inputEl.value };
    const candidateVariant = getMatchingVariant(candidateOptions, variantsData, optionNames);

    let statusText = '';
    if (!candidateVariant) {
      statusText = strings.unavailable;
    } else if (!candidateVariant.available) {
      statusText = strings.soldOut;
    }

    labelEl.toggleAttribute(UNAVAILABLE_ATTR, Boolean(statusText));
    const statusEl = labelEl.querySelector('[data-variant-status]');
    if (statusEl) statusEl.textContent = statusText ? ` — ${statusText}` : '';
  });
};

export default updateVariantAvailability;
